import clsx from "clsx";
import { Link, navigate } from "gatsby";
import React from "react";
import { FaLock } from "react-icons/fa";
import { useSelector } from "react-redux";
import styles from "./TrainingsPanel.module.css";

const TrainingsPanel = ({ modules, setShowSignup,page}) => {
  const { name, tempEmail } = useSelector(
    (state) => state.Pricing
  );
  return (
    <>
      <div className={styles.panel}>
        <div className={styles.container}>
          <div className={styles.heading}>
            <h5>Trainings</h5>
          </div>
          <ul className={styles.items}>
            <li>
              <div>
                <input type="checkbox" checked={page==='sign-up'} />
                <span />
              </div>
              <Link
                className={styles.panelLinks}
                to={`/${
                  modules?.length ? modules[0]?.url : "cost-to-make-an-app/"
                }`}
              >
                {modules?.length ? modules[0]?.title : "---"}{" "}
              </Link>
            </li>
            <li>
              <div>
                <input type="checkbox" checked={page!=='sign-up'} />
                <span />
              </div>
              <button
                className={clsx(styles.panelLinks, styles.btnLink)}
              
                onClick={() => {
                  if(name && tempEmail){
                    navigate(`/${modules[1]?.url}`)
                  }else{
                    setShowSignup(true)
                  }
                  }}
              >
                {modules?.length ? modules[1]?.title : "---"}
              </button>
            </li>
            {modules?.length
              ? modules?.slice(2, modules?.length)?.map((module) => (
                  <li>
                    <FaLock />
                    <Link className={styles.panelLinks} htmlFor="good">
                      {modules?.length ? module?.title : "---"}
                    </Link>
                  </li>
                ))
              : "---"}
          </ul>
        </div>
      </div>
    </>
  );
};
export default TrainingsPanel;
